module.exports = __webpack_public_path__ + "static/media/banner.f514219b.png";